import React, { useEffect, useState } from "react";
import AppBrand from "../components/common/AppBrand";
import NavigationModal from "./NavigationModal";
import { Link } from "react-router-dom";
import ContainerLoading from "./ContainerLoading";
import DetailHeader from "../components/details/detailsheader/DetailHeader";
import { useSelector } from "react-redux";
import AutoComplete from "./AutoComplete";
import { ToastContainer } from "react-toastify";
import Cookies from "js-cookie";

const Header = ({
  isNavigationModal,
  closeNavigationModal,
  openNavigationModal,
  isDetailPage = false,
  isLoading = false,
  detailsState = {},
  setDetailsState,
  handleReleaseConfirm,
}) => {
  const [state, setState] = useState({ headerFilter: "", headerFilterVal: "" });
  const user = useSelector((state) => state.user);

  const detailsStore = useSelector((state) => state.details);
  let { caseDetails, statuses, substatuses, holdStatus, holdCaseDetails } =
    detailsState;

  useEffect(() => {
    let csrfToken = Cookies.get("csrfToken");
    sessionStorage.csrfToken = localStorage.csrfToken;
  }, []);

  return (
    <span>
      <ToastContainer
        closeOnClick={false}
        draggable={false}
        closeButton={false}
      />

      <NavigationModal
        closeNavigationModal={closeNavigationModal}
        showNavigationModal={isNavigationModal}
      />

      <div className="container-fluid">
        <div className="row">
          <header
            className={`header posrelative ${
              isDetailPage ? "detail-page-header-style" : ""
            }`}
          >
            <div
              className="menu-icon exp_nav"
              id="menu-icon"
              onClick={(e) => {
                openNavigationModal();
                e.stopPropagation();
              }}
            >
              <div onClick={openNavigationModal}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>

            <div
              className={`navbar navbar-ason ${
                isDetailPage ? "detail-page-menu-style" : ""
              }`}
              style={{ marginLeft: "3.1em" }}
            >
              <div className="navbar-header">
                <Link className="navbar-brand pull-left" to="/">
                  <AppBrand className="app-brand--header" />
                </Link>
              </div>

              <div className="header_filter">
                <div className="col-lg-4 col-md-4 pad-LR filter_col">
                  <div className="col-lg-6 col-md-6 pad-LR">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="search_field"
                        id="search_field"
                        onChange={(e) =>
                          setState({ ...state, headerFilter: e.target.value })
                        }
                      >
                        <option value="Loan ID">Loan ID</option>
                        <option value="Customer Name">Customer Name</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 pad-LR">
                    <div className="form-group">
                      <AutoComplete
                        searchType={
                          state.headerFilter ? state.headerFilter : "Loan ID"
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              {isDetailPage ? (
                <div className="right-header">
                  {(() => {
                    holdStatus = holdStatus ? holdStatus : -1;
                    const resolvedStatus = holdCaseDetails
                      ? holdCaseDetails.resolved_status
                      : -1;
                    if (holdStatus === 2) {
                      return (
                        <>
                          <input
                            type="hidden"
                            id="case_hold_status"
                            value="1"
                          ></input>
                          <button
                            className="btn btn-danger pull-right holdcase-button"
                            onClick={handleReleaseConfirm}
                            disabled={detailsStore.formLoading}
                          >
                            Release Case
                          </button>
                          {resolvedStatus && resolvedStatus !== -1 ? (
                            <span className="label label-success pull-right hold-reasons-resolved-label">
                              Hold reasons are resolved
                            </span>
                          ) : (
                            ""
                          )}
                        </>
                      );
                    } else if (holdStatus === 1) {
                      return (
                        user?.role_id === 6 &&
                        [2, 3, 4, 12, 14].includes(
                          parseInt(caseDetails.sub_stage)
                        ) && (
                          <button
                            className="btn btn-default btn-green pull-right holdcase-button"
                            onClick={(e) => {
                              setDetailsState({
                                ...detailsState,
                                showHoldCaseModal: true,
                              });
                              e.stopPropagation();
                            }}
                            disabled={detailsStore.formLoading}
                          >
                            Hold Case
                          </button>
                        )
                      );
                    } else if (holdStatus === 3) {
                      return (
                        <>
                          <input
                            type="hidden"
                            id="case_hold_status"
                            value="1"
                          />
                          <input
                            type="button"
                            className="btn btn-danger pull-right holdcase-button"
                            value="On-Hold Case"
                          />
                        </>
                      );
                    }
                  })()}
                </div>
              ) : (
                ""
              )}

              <div className="navbar-collapse mNone-xs">
                <ul className="nav navbar-nav navbar-right notification-mob">
                  <li className="pull-left mNone-sm">
                    <div className="fcm_search"></div>
                  </li>
                </ul>
              </div>
            </div>
            {!isLoading && isDetailPage ? (
              <DetailHeader
                caseDetails={caseDetails}
                user_id={user ? user.id : 0}
                statuses={statuses}
                substatuses={substatuses}
              />
            ) : isDetailPage ? (
              <div className="col-md-12 headpaymentbox" id="headpaymentbox">
                <ContainerLoading />
              </div>
            ) : (
              ""
            )}
          </header>
        </div>
      </div>
      <div className="clearfix"></div>
    </span>
  );
};

export default Header;
